var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 50,
    viewBox: "0 0 25 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9691 49.9807V39.2456C8.06965 38.9073 5.47515 37.4376 3.53588 35.2387C1.35185 32.7616 0 29.3487 0 25.5899C0 21.3462 0.933871 13.1633 3.58484 7.2883C5.48269 3.08597 8.26921 0 12.257 0C16.2485 0 19.035 3.08973 20.9291 7.2883C23.58 13.1595 24.5139 21.3424 24.5139 25.5899C24.5139 29.3487 23.1621 32.7616 20.978 35.2387C19.0388 37.4376 16.4443 38.9073 13.5448 39.2456V49.9807M8.00939 30.995C6.67261 29.9651 8.24285 27.9316 9.5834 28.9615L11.1085 30.1305V21.7972C11.1085 20.102 13.6879 20.102 13.6879 21.7972V25.5861L14.7724 24.4134C15.9171 23.1692 17.815 24.9095 16.6665 26.1537L13.6841 29.3787V36.6294C15.7552 36.2761 17.6154 35.1635 19.0425 33.5435C20.8274 31.5175 21.9307 28.7097 21.9307 25.5974C21.9307 21.5755 21.0571 13.8474 18.5756 8.35204C17.0731 5.02551 15.0096 2.58229 12.2532 2.58229C9.49679 2.58229 7.42948 5.02551 5.93078 8.35204C3.45303 13.8436 2.57566 21.5755 2.57566 25.5974C2.57566 28.7097 3.67897 31.5212 5.46386 33.5435C6.95126 35.2312 8.91689 36.3738 11.1009 36.6708V33.3781L8.00939 30.995Z",
    fill: "#A67B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/about-icon.80344e45e00d61d5618e167b5956938a.svg";
export { ForwardRef as ReactComponent };